import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import {
  address,
  blockSpecialCharachters,
  buesinessIdentification,
  city,
  dose_input,
  GOOGLE_RECAPTCHA_SITE_KEY,
  name_input,
  number_input,
  phoneNumber,
  textareaBox,
  USER_TYPES,
  zipCode
} from 'src/app/constant/constant';
import { UserTypes } from 'src/app/models/User';
import { ProviderRegistrationData } from 'src/app/models/provider';
import { CountriesService } from 'src/app/services/countries.service';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { ApiResult } from 'src/app/models/PromiseResult';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DoctorReferralService } from 'src/app/services/doctor-referral.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { GraphqlService } from 'src/app/services/graphql.service';
import { ApolloError } from '@apollo/client/errors';


@Component({
  selector: 'app-provider-registration',
  templateUrl: './provider-registration.component.html',
  styleUrls: ['./provider-registration.component.css', './../login-home/login-home.component.css']
})
export class ProviderRegistrationComponent implements OnInit {
  @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
  readonly buesinessIdentification: RegExp = buesinessIdentification;
  readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
  readonly user_types: UserTypes = USER_TYPES;
  slug : string = "";
  max_date: Date = this.utilitiesService.getMaxDate();
  logo_url: string = '';
  provider_id: string = "";
  providerreg: ProviderRegistrationData = new ProviderRegistrationData();
  constructor(
    private readonly countriesService: CountriesService,
    private readonly utilitiesService: UtilitiesService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly graphqlService: GraphqlService,
    private readonly refferalService: DoctorReferralService,
    private providerStateService: ProviderStateService
  ) {
    this.max_date = this.utilitiesService.getMaxDate();
  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    this.providerreg = new ProviderRegistrationData();
    this.provider_id = this.providerStateService.getProviderId();
    await this.getCountries();
    this.providerreg.other_data.recaptchaData.reset();
    this.logo_url = this.providerStateService.getLogoUrl();
  }

  async getCountries(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele) => {
          ele["final_value"] = JSON.stringify({
            id: Number(ele.id),
            is_national_license: ele.is_national_license,
            phone_code: '+' + String(ele.phone_code)
          } as CountrySelectedValue);
        });
        this.providerreg.other_data.countries = this.utilitiesService.getSelectItemList(countries, "country_name", "final_value");
      }).catch((err) => {
        console.error(err);
      });
  }

  async onChangeCountry() {
    this.providerreg.other_data.selected_country_data =
      (JSON.parse(
        this.providerreg.other_data.selected_country
      ) as CountrySelectedValue) || new CountrySelectedValue();
  }


  async openLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(
      base_url_name,
      link,
      target
    );
  }


  resolved(captchaResponse: any) {
    this.providerreg.other_data.recaptchaData.recaptcha_value = captchaResponse;
    this.providerreg.api_data.provider.recaptcha =
      this.providerreg.other_data.recaptchaData.recaptcha_value;
  }

  isPosting(): boolean {
    return this.providerreg.api_data.create_api_result.Posting ||
      this.providerreg.api_data.otp_data.otp_api_result.Posting
  }

  async providerRegistrationSubmit() {
    this.providerreg.api_data.create_api_result = new ApiResult(true);
    this.providerreg.api_data.provider.country_id = Number(
      this.providerreg.other_data.selected_country_data.id
    );
    this.providerreg.api_data.provider.phone_number =
      this.providerreg.other_data.selected_country_data.phone_code +
      this.providerreg.other_data.primary_contact_no;

    const name = [this.providerreg.other_data.first_name, this.providerreg.other_data.middle_name, this.providerreg.other_data.last_name]
      .filter(Boolean)
      .join(' ');

    const input = {
      contact_name: name,
      name: this.providerreg.api_data.provider.name,
      country_id: this.providerreg.api_data.provider.country_id,
      email: this.providerreg.api_data.provider.email,
      phone_number: this.providerreg.api_data.provider.phone_number,
      recaptcha: this.providerreg.api_data.provider.recaptcha,
      password: this.providerreg.api_data.provider.password,
      identification_number: this.providerreg.api_data.provider.identification_number,
      shortName: this.providerreg.api_data.provider.shortName
    };

    this.graphqlService.addProvider(input).subscribe(
      (result) => {
        console.log({ result })
        this.providerreg.api_data.otp_data.OTP_validate_api.user_guid = result.data['addProvider'].user_guid;
        this.providerreg.api_data.otp_data.OTP_validate_api.service_id = result.data['addProvider'].service_id;
        this.providerreg.api_data.otp_data.OTP_validate_api.retry_after = new Date(result.data['addProvider'].retry_after);
        this.providerreg.other_data.tabViewData.nextTab(1);
        this.providerreg.api_data.create_api_result.Posting = false;
      },
      (error: ApolloError) => {
        if (error.graphQLErrors) {
          this.providerreg.other_data.recaptchaData.reset();
          for (const graphQLError of error.graphQLErrors) {
            // Handle specific GraphQL error codes
            if (graphQLError.extensions.code === 'BAD_REQUEST') {
              const messages: string[] = graphQLError.extensions.originalError.message
              this.providerreg.api_data.create_api_result.ServerError.error = messages.join(",")
              this.providerreg.api_data.create_api_result.ServerError.message = messages
              this.providerreg.api_data.create_api_result.ServerError.statusCode = 400
            }
            else if (graphQLError.extensions.code === 'INTERNAL_SERVER_ERROR') {
              const messages: string[] = [graphQLError.message]
              this.providerreg.api_data.create_api_result.ServerError.error = messages.join(",")
              this.providerreg.api_data.create_api_result.ServerError.message = messages
              this.providerreg.api_data.create_api_result.ServerError.statusCode = 400
            }
            else {
              const messages: string[] = ['Something went wrong!!']
              this.providerreg.api_data.create_api_result.ServerError.error = null
              this.providerreg.api_data.create_api_result.ServerError.message = messages
              this.providerreg.api_data.create_api_result.ServerError.statusCode = 500
            }
          }
        } else if (error.networkError) {
          const messages: string[] = ['Network Error']
          this.providerreg.api_data.create_api_result.ServerError.error = messages.join(",")
          this.providerreg.api_data.create_api_result.ServerError.message = messages
          this.providerreg.api_data.create_api_result.ServerError.statusCode = 500
        }

        this.providerreg.api_data.create_api_result.PromiseResult.success = false;
        this.providerreg.api_data.create_api_result.Posting = false;
      }
    );
  }
  async otp_resend() {
    this.providerreg.api_data.otp_data.OTP_validate_api.retry = true;
    await this.register_validate_or_resend_otp();
  }
  async otpVerifySubmit() {
    this.providerreg.api_data.otp_data.OTP_validate_api.retry = false;
    await this.register_validate_or_resend_otp();
  }

  async register_validate_or_resend_otp() {
    this.providerreg.api_data.otp_data.otp_api_result = new ApiResult(true);
    await this.refferalService
      .register_doctor_validate_or_resend_otp(this.providerreg.api_data.otp_data.OTP_validate_api)
      .toPromise()
      .then(async (result) => {
        this.providerreg.api_data.otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.providerreg.api_data.otp_data.OTP_validate_api.retry) {
            this.providerreg.api_data.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
            this.providerreg.api_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
            this.providerreg.api_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
            this.changeDetector.detectChanges();
            this.OTP_Input.init_countdown();
          }
          else {
            this.utilitiesService.RouterNavigation(
              '/user/thank-you/' + this.user_types['DOCTOR']
            );
          }
        }
        this.providerreg.api_data.otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.providerreg.api_data.otp_data.otp_api_result.ServerError = error.error;
        this.providerreg.api_data.otp_data.otp_api_result.PromiseResult.success = false;
        this.providerreg.api_data.otp_data.otp_api_result.Posting = false;
      })
  }

}

